import { createFileRoute } from '@tanstack/react-router'
import { ProductCategoryEditView } from '@/features/product-categories/product-categories'

export const Route = createFileRoute('/_authenticated/product-categories/$categoryId/edit')({
  component: ProductCategoryEditView,
})
